import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "../../../hooks/useAppContext";

interface IMapStyle {
	name: string;
	id: string;
	url: string;
}

/**
 * Get all styles with a thumb url
 */
export const useMapStyles = () => {
	const { context, reactQueryNoReloadOptions } = useAppContext();

	const getMapStylesAsync = async () => {
		const res = await fetch(`${context.osmTileServerUrl}/styles.json`);

		const styles = (await res.json()) as IMapStyle[];

		const stylesWithThumb = styles.map((style) => {
			return {
				...style,
				url: `${context.osmTileServerUrl}/styles/${style.id}/14/8391/5497.png`,
			};
		});

		return stylesWithThumb.reverse(); // Basic style as first entry
	};

	return useQuery(["use-map-styles", context.osmTileServerUrl], getMapStylesAsync, {
		enabled: !!context.osmTileServerUrl,
		...reactQueryNoReloadOptions,
	});
};
